/** FZ lab — sync-only cases; no portal create / no uploads. */
export const FZ_TOKEN = "FZ";

export function isFzToken(token?: string | null): boolean {
  return String(token || "").trim().toUpperCase() === FZ_TOKEN;
}

export function isFzCaseId(caseId?: string | null): boolean {
  return String(caseId || "")
    .trim()
    .toUpperCase()
    .startsWith(FZ_TOKEN);
}

function pushUniqueName(names: string[], value: unknown) {
  const name = String(value ?? "").trim();
  if (!name) return;
  if (names.some((existing) => existing.toLowerCase() === name.toLowerCase())) {
    return;
  }
  names.push(name);
}

function collectNameList(value: unknown, names: string[]) {
  if (typeof value === "string") {
    pushUniqueName(names, value);
    return;
  }
  if (!Array.isArray(value)) return;
  for (const item of value) {
    if (typeof item === "string") {
      pushUniqueName(names, item);
    } else if (item && typeof item === "object") {
      const record = item as { patient?: unknown; name?: unknown };
      pushUniqueName(names, record.patient ?? record.name);
    }
  }
}

/** Patient names for an FZ case. Names are stored on details_json (no Box files). */
export function fzPatientNamesFromDetails(details: unknown): string[] {
  let parsed: Record<string, unknown> | null = null;
  if (typeof details === "string") {
    try {
      const json = JSON.parse(details);
      if (json && typeof json === "object" && !Array.isArray(json)) {
        parsed = json;
      }
    } catch {
      parsed = null;
    }
  } else if (details && typeof details === "object" && !Array.isArray(details)) {
    parsed = details as Record<string, unknown>;
  }
  if (!parsed) return [];

  const names: string[] = [];
  collectNameList(parsed.patientNames, names);
  if (!names.length) collectNameList(parsed.patientName, names);
  return names;
}
